import http from '@/plugins/api'
import { startLoading } from '@/plugins/loading'
import * as types from './types'

export default {
  setSearchTerm({ commit }, text) {
    commit(types.SET_SEARCH_TERM, text)
  },
  setPageSize({ commit }, pageSize) {
    commit(types.SET_PAGE_SIZE, pageSize)
  },
  setRetrospectiveDay({ commit }, days) {
    commit(types.SET_DAYS, days)
  },
  setSortDir({ commit }, sortDir) {
    commit(types.SET_SORT_DIR, sortDir)
  },
  setOrderBy({ commit }, orderBy) {
    commit(types.SET_ORDER_BY, orderBy)
  },
  setFilterBy({ commit }, filterBy) {
    commit(types.SET_FILTER_BY, filterBy)
  },
  setFilterOptions({ commit }, data) {
    commit(types.SET_FILTER_OPTIONS, data)
  },
  setUserChecked({ commit }, data) {
    commit(types.SET_USER_CHECKED, data)
  },
  async setUserEmail({ commit, dispatch }, data) {
    await startLoading(dispatch, 'setUserEmail', () =>
      http.get('user/saveUserEmail', {
        params: data
      })
    )
    commit(types.SET_EMAIL, data)
  },
  setUser({ commit }, data) {
    commit(types.SET_USER, data)
  },
  addUser({ commit }, data) {
    commit(types.ADD_USER, data)
  },
  updateUser({ commit }, data) {
    commit(types.UPDATE_USER, data)
  },
  setFirm({ commit }, firm) {
    commit(types.SET_FIRM, firm)
  },
  setPrimaryFirm({ commit }, firm) {
    commit(types.SET_PRIMARY_FIRM, firm)
  },
  async getRoles({ commit, dispatch }, firm) {
    const r = await startLoading(dispatch, 'getRoles', () => http.get(`user/roles?firm=${firm}`))
    commit(types.SET_ROLES, r.data)
    return r.data
  },
  async getUser({ commit, dispatch }, username) {
    const r = await startLoading(dispatch, 'getUser', () =>
      http.get('user/profile', {
        params: {
          username: username
        }
      })
    )
    commit(types.SET_USER, r.data)
    return r.data
  },
  async getUsers({ commit, dispatch }, searchOptions) {
    const r = await startLoading(dispatch, 'getUsers', () =>
      http.get('user/users', {
        params: searchOptions
      })
    )
    commit(types.SET_USERS, r.data)
    return r.data
  },
  async verifyUsername({ commit, dispatch }, username) {
    const r = await startLoading(dispatch, 'verifyUsername', () => http.get(`user/verifyUsername?username=${username}`))
    return r.data
  },
  async saveUser({ commit, state, dispatch }, data) {
    const r = await startLoading(dispatch, 'saveUser', () => http.post('user/saveUser', state.user))
    return r.data
  },
  async deleteUsers({ commit, state, dispatch }, users) {
    const r = await startLoading(dispatch, 'deleteUsers', () => http.post('user/deleteUsers', users))
    return r.data
  },
  async saveCredentials({ commit, state, dispatch }, data) {
    const r = await startLoading(dispatch, 'saveCredentials', () => http.post('user/saveCredentials', data))
    return r.data
  },
  async updateUserParams({ commit, state, dispatch }, data) {
    const r = await startLoading(dispatch, 'updateUserParams', () => http.post('user/updateUserParams', data))
    return r.data
  },
  async activateUsers({ commit, state, dispatch }, users) {
    const r = await startLoading(dispatch, 'activateUsers', () => http.post('user/activateUsers', users))
    for (let user of users) {
      var status = false
      if (user.token === '1') {
        status = true
      }
      commit(types.SET_USER_CHECKED, { username: user.username, isChecked: status })
    }
    return r.data
  },
  async getUserFirms({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'getUserFirms', () => http.get(`user/userLocations?user=${data.user}&isAll=${data.isAll}`))
    commit(types.SET_USER_FIRMS, {
      user: data.user,
      data: r.data
    })
    return r.data
  },
  async saveUserFirms({ commit, state, dispatch }, data) {
    var r
    var firms = JSON.parse(JSON.stringify(state.userFirms.filter((x) => x.checked === true)))
    if (firms) {
      firms.forEach((element) => {
        element.userFirm = null
      })
      r = await startLoading(dispatch, 'saveUserFirms', () => http.post('user/saveUserLocations', firms))
    }
    return r.data
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/users/actions.js